import api from './api';

const fileUploadService = {
  // Upload a single file
  uploadFile: async (file, documentType) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('documentType', documentType);
      
      const response = await api.post('/upload/document', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      
      return response.data;
    } catch (error) {
      console.error('Error uploading file:', error);
      throw error;
    }
  },

  // Get file URL for viewing (using authenticated API)
  getFileUrl: (fileName) => {
    // Use the authenticated API instance instead of direct URL
    return `${import.meta.env.VITE_API_BASE_URL || 'http://localhost:5000/api'}/documents/${fileName}`;
  },

  // Get file with authentication
  getFile: async (fileName) => {
    try {
      const response = await api.get(`/documents/${fileName}`, {
        responseType: 'blob'
      });
      return response;
    } catch (error) {
      console.error('Error getting file:', error);
      throw error;
    }
  },

  // Download file
  downloadFile: async (fileName) => {
    try {
      const response = await api.get(`/documents/download/${fileName}`, {
        responseType: 'blob',
      });
      
      // Create blob link to download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading file:', error);
      throw error;
    }
  },

  // Delete file
  deleteFile: async (fileName) => {
    try {
      const response = await api.delete(`/documents/${fileName}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting file:', error);
      throw error;
    }
  }
};

export default fileUploadService;
